module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Blue.e0948b47.png";